import Vue from "vue";

const others = {
    namespaced: true,
    state: () => ({
        preLoading: true,
        loading: false,
        confirmationTooltip: false,
        confirmationBase: null,
        treatment: {}
    }),
    mutations: {
        setTreatment (state, payload) {
            Vue.set(state.treatment, payload.key, payload.value);
        },
        setPreLoading (state, payload) {
            if (payload === false) {
                setTimeout(() => {
                    state.preLoading = payload;
                }, 1);
            } else {
                state.preLoading = payload;
            }
        },
        setLoading (state, payload) {
            if (payload === false) {
                setTimeout(() => {
                    state.loading = payload;
                }, 1);
            } else {
                state.loading = payload;
            }
        },
        setConfirmationTooltip (state, payload) {
            state.confirmationTooltip = payload;
        },
        setConfirmationBase (state, payload) {
            state.confirmationBase = payload;
        }
    },
    getters: {
        getPreLoading: (state) => {
            return state.preLoading;
        },
        getLoading: (state) => {
            return state.loading;
        },
        getConfirmationTooltip: (state) => {
            return state.confirmationTooltip;
        },
        getConfirmationBase: (state) => {
            return state.confirmationBase;
        },
        getTreatment: (state) => treatmentKey => {
            return state.treatment[treatmentKey] && state.treatment[treatmentKey] !== "control" ? state.treatment[treatmentKey] : null;
        }
    },
    actions: {}
};

export default others;
